import {
	IMAGE_GENERATION_SECONDS,
	VIDEO_GENERATION_SECONDS,
} from '@/common/constants/generationEstimates';
import GenerationLoading from './components/GenerationLoading';
import TextTypingPlaceholder from './components/TextTypingPlaceholder';
import { PlaceholderWrapper } from './loadingPlaceholders.styles';

const LoadingPlaceholders = ({
	isGenerating,
	isGeneratingVideo,
	isTextGenerating,
	isTranscribing,
	isChecking,
}) => (
	<>
		{(isChecking || isTextGenerating) && (
			<TextTypingPlaceholder
				labelKey={isChecking ? 'thinking' : 'typing'}
			/>
		)}
		{isGenerating && (
			<PlaceholderWrapper>
				<GenerationLoading
					labelKey="generatingImage"
					estimateKey="estimatedTimeRemaining"
					totalDuration={IMAGE_GENERATION_SECONDS}
				/>
			</PlaceholderWrapper>
		)}
		{isGeneratingVideo && (
			<PlaceholderWrapper>
				<GenerationLoading
					labelKey="generatingVideo"
					estimateKey="estimatedVideoTimeRemaining"
					totalDuration={VIDEO_GENERATION_SECONDS}
				/>
			</PlaceholderWrapper>
		)}
		{isTranscribing && (
			<TextTypingPlaceholder labelKey="processingMessage" alignRight />
		)}
	</>
);

export default LoadingPlaceholders;
